import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Row
} from "reactstrap";
import { createCard } from "../../providers/paymentProvider";
import Toast from "../utils/Toast";
import { updateProfessionalAccount } from "../../providers/userProvider";

class BankInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountInfo: {
        holderName: "",
        accountTaxPayer: "",
        bankAccount: "",
        bankAgency: ""
      },
      successMessage: "",
      errorMessage: ""
    };
  }

  componentDidMount() {
    this.onChange({
      ...this.props.accountInfo
    });
  }

  onChange = updateObj => {
    this.setState(prevState => ({
      accountInfo: {
        ...prevState.accountInfo,
        ...updateObj
      }
    }));
  };

  send = async e => {
    e.preventDefault();
    console.log(this.state.accountInfo);
    const result = await updateProfessionalAccount(
      this.props.user._id,
      this.props.user.token,
      this.state.accountInfo
    );
    console.log(result);
  };

  render() {
    const {
      holderName,
      accountTaxPayer,
      bankAccount,
      bankAgency
    } = this.state.accountInfo;

    console.log(this.state.accountInfo);

    return (
      <React.Fragment>
        <h3>Informações bancárias</h3>

        <Form>
          <Row>
            <Col xs="12" sm="6">
              <FormGroup>
                <Label>CPF:</Label>
                <Input
                  value={accountTaxPayer}
                  onChange={e =>
                    this.onChange({ accountTaxPayer: e.target.value })
                  }
                />
              </FormGroup>
            </Col>
            <Col xs="12" sm="6">
              <FormGroup>
                <Label>Nome do titular:</Label>
                <Input
                  value={holderName}
                  onChange={e => this.onChange({ holderName: e.target.value })}
                />
              </FormGroup>
            </Col>
            <Col xs="12" md="6">
              <FormGroup>
                <Label>Agência:</Label>
                <Input
                  value={bankAgency}
                  onChange={e => this.onChange({ bankAgency: e.target.value })}
                />
              </FormGroup>
            </Col>
            <Col xs="12" md="6">
              <FormGroup>
                <Label>Número da conta:</Label>
                <Input
                  value={bankAccount}
                  onChange={e => this.onChange({ bankAccount: e.target.value })}
                />
              </FormGroup>
            </Col>
          </Row>
          <Button onClick={this.send}>Salvar Alterações</Button>
        </Form>

        {this.state.successMessage ? (
          <Toast message={this.state.successMessage} type="success" />
        ) : null}
        {this.state.errorMessage ? (
          <Toast message={this.state.errorMessage} type="error" />
        ) : null}
      </React.Fragment>
    );
  }
}

export default BankInfo;
